import {mountVueApps} from "../vue/vue-mount";
import {Slider} from "./component/slider";
import {TrailerCarousel} from "./component/trailer-carousel";
import {Share} from "./component/share";
import {NavigationDrawer} from "./component/navigation-drawer";
import {ShareService} from "../vue/service/ShareService";
import {OverlayService} from "../vue/service/OverlayService";

import {OsmMap} from "./component/osm-map";

window.ShareService = ShareService;
window.OverlayService = OverlayService;

mountVueApps();
new Slider();
new TrailerCarousel();
new Share();
new NavigationDrawer();

new OsmMap();
